/* Welt-Pasta-Tag 2026 — Landingpage · Runde 01 (17.10.2026)
   Hero (rohe Pasta fällt ein und schwebt, Parallaxe), Code kopieren, Warenkorb
   mit automatisch eingelöstem Code, Zahlen zählen hoch, Karten kippen zur Maus.
   Ohne JS: Seite vollständig, Kauf-Knöpfe sind normale Warenkorb-Formulare,
   der Code steht lesbar da. */
(function () {
  'use strict';
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fein = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function einblenden() {
    var el = document.querySelectorAll('.wpt [data-rv]');
    if (!('IntersectionObserver' in window)) { el.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    el.forEach(function (e) { io.observe(e); });
  }

  function hero() {
    var h = document.querySelector('.wpt-hero');
    if (!h) return;
    var b = h.querySelector('.wpt-buehne'), bild = h.querySelector('.wpt-szene img');
    function messen() { h.style.setProperty('--wpt-oben', Math.min(220, Math.max(0, Math.round(h.getBoundingClientRect().top + window.scrollY))) + 'px'); }
    messen(); window.addEventListener('resize', messen, { passive: true }); window.addEventListener('load', messen);
    var an = false; function los() { if (!an) { an = true; h.classList.add('ist-an'); } }
    if (ruhig || !bild || bild.complete) requestAnimationFrame(los);
    else { bild.addEventListener('load', los, { once: true }); bild.addEventListener('error', los, { once: true }); setTimeout(los, 1600); }
    if (ruhig) return;
    var mx = 0, my = 0, zx = 0, zy = 0, lauf = false;
    if (fein) {
      h.addEventListener('pointermove', function (e) { var r = h.getBoundingClientRect(); zx = (e.clientX - r.left) / r.width * 2 - 1; zy = (e.clientY - r.top) / r.height * 2 - 1; stoss(); });
      h.addEventListener('pointerleave', function () { zx = 0; zy = 0; stoss(); });
    }
    window.addEventListener('scroll', stoss, { passive: true });
    function stoss() { if (!lauf) { lauf = true; requestAnimationFrame(schritt); } }
    function schritt() {
      mx += (zx - mx) * .08; my += (zy - my) * .08;
      var r = b.getBoundingClientRect(), sp = Math.min(1, Math.max(0, -r.top / r.height));
      b.style.setProperty('--mx', mx.toFixed(4)); b.style.setProperty('--my', my.toFixed(4)); b.style.setProperty('--sp', sp.toFixed(4));
      if (Math.abs(zx - mx) > .002 || Math.abs(zy - my) > .002) requestAnimationFrame(schritt); else lauf = false;
    }
  }

  /* Code kopieren — Zwischenablage, sonst markieren */
  function kopieren() {
    document.querySelectorAll('.wpt [data-kopieren]').forEach(function (k) {
      k.addEventListener('click', function () {
        var code = k.getAttribute('data-kopieren'), karte = k.closest('.wpt-code'), alt = k.getAttribute('data-text') || k.textContent;
        k.setAttribute('data-text', alt);
        function fertig() {
          k.classList.add('ist-kopiert'); k.textContent = k.getAttribute('data-fertig') || 'Kopiert';
          if (karte && !ruhig) { karte.classList.remove('ist-gestempelt'); void karte.offsetWidth; karte.classList.add('ist-gestempelt'); }
          setTimeout(function () { k.classList.remove('ist-kopiert'); k.textContent = alt; }, 2600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fertig, markieren);
        else markieren();
        function markieren() {
          var w = karte && karte.querySelector('.wpt-code__wert');
          if (w && window.getSelection) { var r = document.createRange(); r.selectNodeContents(w); var s = getSelection(); s.removeAllRanges(); s.addRange(r); }
          try { document.execCommand('copy'); fertig(); } catch (e) { }
        }
      });
    });
  }

  /* Warenkorb: hinzufügen, Code setzen, über /discount/<code> zur Kasse */
  function kauf() {
    document.querySelectorAll('.wpt form[data-kauf]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var k = f.querySelector('button'); k.classList.add('ist-laedt');
        var id = +f.querySelector('[name="id"]').value, code = f.getAttribute('data-code');
        var json = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        fetch(wurzel + 'cart/add.js', Object.assign({ body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) }, json))
          .then(function (r) { if (!r.ok) throw r; return code ? fetch(wurzel + 'cart/update.js', Object.assign({ body: JSON.stringify({ discount: code }) }, json)) : null; })
          .then(function () { window.location.href = code ? wurzel + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(wurzel + 'cart') : wurzel + 'cart'; })
          .catch(function () { f.submit(); });
      });
    });
  }

  function zaehlen() {
    var el = document.querySelectorAll('.wpt [data-zaehlen]');
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        var z = e.target, ziel = parseFloat(z.getAttribute('data-zaehlen')), start = null;
        if (isNaN(ziel)) return;
        (function f(t) { if (!start) start = t; var k = Math.min(1, (t - start) / 1600), w = 1 - Math.pow(1 - k, 3);
          z.textContent = Math.round(ziel * w); if (k < 1) requestAnimationFrame(f); else z.textContent = z.getAttribute('data-zaehlen'); })(performance.now());
      });
    }, { threshold: .6 });
    el.forEach(function (x) { io.observe(x); });
  }

  /* Karten kippen leicht zur Maus */
  function kippen() {
    if (ruhig || !fein) return;
    document.querySelectorAll('.wpt-karte').forEach(function (k) {
      k.addEventListener('pointermove', function (e) {
        var r = k.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        k.style.setProperty('--ky', (x * 7).toFixed(2) + 'deg'); k.style.setProperty('--kx', (-y * 6).toFixed(2) + 'deg');
      });
      k.addEventListener('pointerleave', function () { k.style.setProperty('--ky', '0deg'); k.style.setProperty('--kx', '0deg'); });
    });
  }

  function anker() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.wpt a[href^="#"]');
      if (!a) return;
      var z = document.getElementById(a.getAttribute('href').slice(1));
      if (!z) return;
      e.preventDefault(); z.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function start() { einblenden(); hero(); kopieren(); kauf(); zaehlen(); kippen(); anker(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
